import React from 'react';

import { Container, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import AboutPage from './pages/AboutPage';
import AdminPage from './pages/AdminPage';
import GuidelinesPage from './pages/GuidelinesPage';
import UploadPage from './pages/UploadPage';
import HowItWorksPage from './pages/HowItWorksPage';
import MatrixPage from './pages/MatrixPage';
import MobilePage from './pages/MobilePage';
import { getAvailableWidth } from './components/utils';

function App() {
  return (
    <Router>
      <Container fluid>
        <Row></Row>

        <Switch>
          <Route path="/about">
            <AboutPage />
          </Route>
          <Route path="/how-it-works">
            <HowItWorksPage />
          </Route>
          <Route path="/upload">
            <UploadPage />
          </Route>
          <Route path="/admin">
            <AdminPage />
          </Route>
          <Route path="/snippets">
            <GuidelinesPage />
          </Route>
          <Route path="/mobile">
            <MobilePage />
          </Route>
          <Route path="/desktop">
            <MatrixPage />
          </Route>
          <Route path="/">
            {getAvailableWidth() > 800 ? <MatrixPage /> : <MobilePage />}
          </Route>
        </Switch>
      </Container>
    </Router>
  );
}

export default App;
